import { useEffect } from 'react';
import { SelectedMetrics, StorageLocation } from '../../../Types/AnalyticsGraph';

export const useDataFetching = (
    isUserZoom: boolean,
    currentEpochStartDate: number | null,
    currentEpochEndDate: number | null,
    zoomStartIndex: number,
    zoomEndIndex: number,
    selectedMetrics: SelectedMetrics,
    submitDataFetch: (timeData: object, selectedMetrics: SelectedMetrics, selectedStorage: StorageLocation) => Promise<void>,
    selectedStorage: StorageLocation
) => {
    useEffect(() => {
        if (!isUserZoom) return;

        // Ensure we have valid, stable start and end dates for the API call
        if (!currentEpochStartDate || !currentEpochEndDate || zoomStartIndex > zoomEndIndex) {
            return;
        }
        // Also ensure we have at least one metric selected
        if (selectedMetrics.agristarMetrics.length === 0 && selectedMetrics.serviceMetrics.length === 0) {
            return;
        }

        const timerId = setTimeout(() => {
            // Prepare data for the API call using the memoized dates
            const apiPayload = {
                startDate: new Date(currentEpochStartDate).toISOString(),
                endDate: new Date(currentEpochEndDate).toISOString(),
            };

            submitDataFetch(apiPayload, selectedMetrics, selectedStorage);

        }, 3000); // 3 seconds delay

        return () => {
            clearTimeout(timerId);
        };
    }, [isUserZoom, currentEpochStartDate, currentEpochEndDate, selectedMetrics, selectedStorage, submitDataFetch]);
};